import { HUtils } from "src/core/helpers"
import { ScreenCode, Path, TitlePage, ConfigPageScreen } from "./path"

export const Sidebar = {
  list: [] as any,
  button_list: [] as any,
  init() {
    const sidebarDev = []
    Sidebar.list = [
      {
        code: ScreenCode.DASHBOARD,
        name: TitlePage[ScreenCode.DASHBOARD],
        url: Path[ScreenCode.DASHBOARD],
        icon: "type:dashboard",
      },
      {
        code: ScreenCode.SEARCH_TASK,
        name: TitlePage[ScreenCode.SEARCH_TASK],
        url: Path[ScreenCode.SEARCH_TASK],
        icon: "type:search",
      },
      // {
      //   code: ScreenCode.CREATE_TASK,
      //   name: TitlePage[ScreenCode.CREATE_TASK],
      //   url: Path[ScreenCode.CREATE_TASK],
      //   icon: "type:create",
      // },
      {
        code: ScreenCode.MY_TASKS,
        name: TitlePage[ScreenCode.MY_TASKS],
        url: Path[ScreenCode.MY_TASKS],
        icon: "type:task",
      },
      {
        code: ScreenCode.SEARCH_COMMUNICATION,
        name: TitlePage[ScreenCode.SEARCH_COMMUNICATION],
        url: Path[ScreenCode.SEARCH_COMMUNICATION],
        icon: "type:search",
      },
      // {
      //   code: ScreenCode.CREATE_COMMUNICATION,
      //   name: TitlePage[ScreenCode.CREATE_COMMUNICATION],
      //   url: Path[ScreenCode.CREATE_COMMUNICATION],
      //   icon: "type:create_commu",
      // },
      {
        code: ScreenCode.MY_COMMUNICATIONS,
        name: TitlePage[ScreenCode.MY_COMMUNICATIONS],
        url: Path[ScreenCode.MY_COMMUNICATIONS],
        icon: "type:commu",
      },
      ...(HUtils.isLocalDev() === true ? sidebarDev : []),
    ]
    Sidebar.button_list = [
      {
        code: ScreenCode.CREATE_TASK,
        name: TitlePage[ScreenCode.CREATE_TASK],
        icon: "type:create",
        type: "modal",
        configPage: ConfigPageScreen[ScreenCode.CREATE_TASK],
      },
      {
        code: ScreenCode.CREATE_COMMUNICATION,
        name: TitlePage[ScreenCode.CREATE_COMMUNICATION],
        icon: "type:create_commu",
        type: "modal",
        configPage: ConfigPageScreen[ScreenCode.CREATE_COMMUNICATION],
      },
    ]
  },
}
